import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalenderRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calender-remove, date-remove"} maskId="square-filled-radius-0-stroke-1-IconCalenderRemove"><path d="M8 2H7V4H3V21H13V20H4V9H20V13H21V4H17V2H16V4H8V2Z" fill="currentColor"/><path d="M15.4962 14.7929L14.7891 15.5L17.2891 18L14.7891 20.5L15.4962 21.2071L17.9962 18.7071L20.4962 21.2071L21.2033 20.5L18.7033 18L21.2033 15.5L20.4962 14.7929L17.9962 17.2929L15.4962 14.7929Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalenderRemove;
